import script from "./RevisionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./RevisionsView.vue?vue&type=script&setup=true&lang=js"

import "./RevisionsView.vue?vue&type=style&index=0&id=fda05ac0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fda05ac0"]])

export default __exports__